<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>

        <div :class="loadMask"></div>

        <default-chart
            :options="settings"
            :labels="labels"
            :items="items"
            :showLegend="showLegend"
            :showGrid="showGrid"
            :dashedLines="dashedLines"
            :zoom="false"
            :height="120"
            :selected="toggle">
        </default-chart>

        <div class="chart-options">
          <label>
            <input type="checkbox" v-model="showLegend" v-on:click="toggleShowLegend"> {{ t('Show legend') }}
          </label>
          <label>
            <input type="checkbox" v-model="showGrid" v-on:click="toggleShowGrid"> {{ t('Show grid') }}
          </label>
          <label>
            <input type="checkbox" v-model="dashedLines" v-on:click="toggleDashedLines"> {{ t('Dashed lines') }}
          </label>

          <label>
            <span>{{ t('Y axis options') }}:</span>
            {{ t('Min') }}
            <input type="number" v-model="yAxisTicks.min" v-on:change="changeYAxisTicks" class="y-axis-option">
            {{ t('Max') }}
            <input type="number" v-model="yAxisTicks.max" v-on:change="changeYAxisTicks" class="y-axis-option">
            {{ t('Step') }}
            <input type="number" v-model="yAxisTicks.step" v-on:change="changeYAxisTicks" class="y-axis-option">
          </label>
        </div>
    </div>
</template>
<script>

import DefaultChart from './DefaultChart';
import ComponentTitle from "./ComponentTitle";

export default {
    components: {ComponentTitle, DefaultChart},
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            Type: Object,
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        },
    },
    data() {
        const _this = this;
        return {
            firstLoading: false,
            items: [],
            labels: [],
            showLegend: false,
            showGrid: false,
            dashedLines: false,
            events: [],
            moduleIndex: null,
            yAxisTicks: {
              min: 0,
              max: 0,
              step: 0,
            },
            settings: {
                tension: 0,
                lineJoin: 'bevel',
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        },
                        gridLines: {
                          display: false
                        },
                        afterBuildTicks: function (axis) {
                          const min = axis.chart.scales['y-axis-0'].min;
                          const max = axis.chart.scales['y-axis-0'].max;

                          _this.yAxisTicks.min = min;
                          _this.yAxisTicks.max = max;
                          _this.yAxisTicks.step = Math.ceil((max - min) / axis.chart.scales['y-axis-0'].ticks.length);
                        },
                    }],
                    xAxes: [{
                        gridLines: {
                          display: false
                        }
                    }]
                },
                showLegend: {
                  display: false
                },
            },
            state: {},
            toggle: false,
            loadMask: '',
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted()
    {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);
            this.moduleIndex = moduleIndex;
            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.mountEvents();

                if ('config' in this.config) {
                    this.setConfig(this.config.config);
                }
            });
        });
    },
    methods:
        {
            init() {
            },
            chart()
            {
                this.firstLoading = true;
                this.loadMask = 'lmask';
                let data = this.state;

                return this.$http.get(this.routeName + '/chart-' + this.config.index, {params: data}).then(response => {
                    this.labels = response.body.labels;
                    this.items = response.body.items;
                    this.loadMask = '';
                });
            },
            mountEvents() {
                this.eventBus.$on(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, (filterName, filterValue, filter, filters, serializedFilters) => {
                    this.state = Object.assign(this.state, serializedFilters);
                    this.chart();
                });
                this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
            },
            setConfig(config) {
                this.dashedLines = 'dashedLines' in config ? config['dashedLines'] : false;
                this.showLegend = 'showLegend' in config ? config['showLegend'] : false;
                this.showGrid = 'showGrid' in config ? config['showGrid'] : false;
            },
            toggleShowLegend() {
              this.showLegend = !this.showLegend;
            },
            toggleShowGrid() {
              this.showGrid = !this.showGrid;
            },
            toggleDashedLines() {
              this.dashedLines = !this.dashedLines;
            },
            changeYAxisTicks() {
              this.$root.$emit('chart:changeYAxisTicks', this.yAxisTicks.min, this.yAxisTicks.max, this.yAxisTicks.step)
            },
            unmountEvents() {
                this.events.forEach(e => {
                    this.eventBus.$off(e);
                });
            }
        }
}

</script>

<style lang="scss">
.chart-options {
  padding: 20px 30px;
  text-align: center;

  .y-axis-option {
    width: 60px;
    margin-right: 10px;
  }
  label {
    margin-right: 20px;
    cursor: pointer;

    input[type="checkbox"] {
      margin-right: 5px;
    }

    span {
      padding-right: 8px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Chart.vue?fcbb12a8